import layout from '@/views/layout/passportMain'

const passwordRouter = [
    {
        path: '/passport',
        component: layout,
        children: [
            {
                path: 'login',
                component: () => import('@/views/passport/login'),
                name: 'login',
                meta: { title: '登录', icon: '', affix: true }
            },
            {
                path: 'register',
                component: () => import('@/views/passport/register'),
                name: 'registerOne',
                meta: { title: '注册', icon: '', affix: true }
            },
            {
                path: 'resetPassword',
                component: () => import('@/views/passport/resetPassword'),
                name: 'resetPassword',
                meta: { title: '重置密码', icon: '', affix: true }
            }
        ]
    }
]
export default passwordRouter;


// WEBPACK FOOTER //
// ./src/router/modules/passwordRouter.js